import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_mention_picker = _resolveComponent("ontos-mention-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "host",
      onKeydownCapture: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args)))
    }, null, 544),
    (_ctx.picking && _ctx.workspace)
      ? (_openBlock(), _createBlock(_component_ontos_mention_picker, {
          key: 0,
          ref: "picker",
          query: _ctx.picking.query,
          target: _ctx.picking.target,
          workspace: _ctx.workspace,
          idea: _ctx.idea,
          onPick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.insert($event))),
          onClose: _ctx.closePicker
        }, null, 8, ["query", "target", "workspace", "idea", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}